import { httpRequest } from "../../../utils/HttpRequest";
import { IPage } from "@/types/ScmTypes";
import { IHistoryQuerySearch, IHistoryQueryDetail } from "./historyQueryType"

class HistoryQueryService {
    async page(searchVo: IHistoryQuerySearch) {
        const apiUrl = "/zzw-vrm/maintenance/historyQuerying";
        return await httpRequest.post<IPage<IHistoryQueryDetail>>(apiUrl, searchVo);
    }
    //导出
    async export(params: object) {
        const apiUrl = "/zzw-vrm/maintenance/export";
        return await httpRequest.postFile(apiUrl, params);
    }

    //变更维修派工
    async changedispatch(params: any) {
        const apiUrl = `/zzw-vrm/maintenance/dispatchChange`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
}
export const historyQueryService = new HistoryQueryService();
